import React from 'react';
import styled from "styled-components";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import {colors} from "../maps/colors";
import Icn from "./Icn";

const WrapperStyled = styled.div`
  display: grid;
  position: relative;
  text-align: center;
  margin-bottom: 10px;
  height: 100%;
  width: 100%;

  .stepFieldItem-children {
    .hidden {
      display: none;
    }
  }

  &:hover {
    .stepFieldItem-children {
      .hidden {
        display: block;
      }
    }
  }

  &.step {
    .color-box {
      background: ${colors.LIGHT_ORANGE};
      width: 11px;
      height: 11px;
    }
  }

  &.field {
    .color-box {
      background: ${colors.ORANGE};
      width: 10px;
      height: 10px;
    }
  }
    
    .mirror{
        height: 8px;
        position: absolute;
        bottom: 15px;
        
        svg{
            width: 17px;
            height: 17px;
        }
    }
`;

const BottomStyled = styled.div`
  text-transform: capitalize;
`;

const InfoStyled = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  justify-self: center;
  align-items: center;
  grid-gap: 5px;
`;

const StepFieldItem = ({
                           isSelected,
                           isCustomMode,
                           type,
                           name,
                           variant = "outlined",
                           isSquare,
                           children,
                           style,
                           rotate,
                           isMuted,
                           hideHrAndIcon = false
                       }) => {
    let padding = '10px 10px 0 10px';
    let nameFont = '22px';
    let typeFont = '22px';
    let elevation = 0;
    let backGroundColor = colors.WHITE;
    let icon = 'sensor';
    let outline = "1px solid #edbf1a";

    if (isCustomMode) {
        let demensionToCount = style?.width;
        if (style?.height > style?.width) {
            demensionToCount = style?.height;
        }
        padding = 0;
        nameFont = `${demensionToCount / 8}px`;
        typeFont = `${demensionToCount / 8}px`;
    }
    if (isSelected) {
        elevation = 24;
    }

    if (type === 'step' && isCustomMode) {
        backGroundColor = colors.LIGHT_ORANGE;
    }
    if (type === 'field' && isCustomMode) {
        icon = 'field';
        backGroundColor = colors.ORANGE;
    }

    if (type === 'shelf') {
        icon = 'shelfIcon';
        if (isCustomMode) {
            backGroundColor = colors.ORANGE;
        }
    }

    if (isMuted) {
        backGroundColor = '#aaaaaa50';
        outline = "1px solid #aaaaaa50";
    }

    return (
        <Paper elevation={elevation} variant={variant} square={isSquare}
               style={{outline: outline, outlineOffset: -1, marginBottom: 10, background: backGroundColor, ...style}}>
            <WrapperStyled className={type} style={{padding}}>
                <InfoStyled style={{
                    fontSize: nameFont,
                    // transform: `rotate(${rotate || 0}deg)`
                    transform: `rotate(0deg)`
                }}>
                    {name}
                    {!isCustomMode && (
                        <div className="color-box"/>
                    )}
                </InfoStyled>
                {!hideHrAndIcon && (
                    <>
                        <Divider variant="fullWidth"/>
                        <BottomStyled style={{margin: `${isCustomMode ? "0" : "4px 0 0 0"}`}}>
                            <Icn style={{fontSize: typeFont}}>{icon}</Icn>
                        </BottomStyled>
                    </>
                )}
                <div className="stepFieldItem-children">
                    {children}
                </div>
            </WrapperStyled>
        </Paper>
    );
};

export default StepFieldItem;